import type { ReferenceDataStoreModel } from "../../../../models/store/reference-data.store.model";

type ReferenceDataModalV1 = Omit<ReferenceDataStoreModel, "v"> & {
  v: 1;
};

export const reference_v1_to_v2 = (reference: ReferenceDataModalV1): ReferenceDataStoreModel => {
  return {
    src: "legacy", // if reference does not have the src field, we default it to "legacy"
    ...reference,
    v: 2,
  };
};
